import { type CourseCardItem, CourseType } from '../../../resources/@types/courseSchema';
import { COURSE_URL, INFLEARN_URL } from '../../constants/urls';

interface GetCourseDetailUrlParams {
  type: CourseCardItem['type'];
  courseSlug: string;
}

export function getCourseDetailUrl({ type, courseSlug }: GetCourseDetailUrlParams) {
  if (type === CourseType.OFF) {
    return INFLEARN_URL.COURSE_OFFLINE_DETAIL(courseSlug);
  }

  if (type === CourseType.CHALLENGE) {
    return COURSE_URL.CHALLENGE_DETAIL(courseSlug);
  }

  return COURSE_URL.COURSE_DETAIL(courseSlug);
}
